import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Dossier/${dossierId}/RecoverEntityFromParent`, method: 'PUT', token: token })
}
